// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"03ff8230","453":"0bcc7a4d"}[chunkId] + ".chunk.js";
};